import { render, staticRenderFns } from "./FeaturedQuestion.vue?vue&type=template&id=4ae8b4f0&scoped=true&"
import script from "./FeaturedQuestion.vue?vue&type=script&lang=js&"
export * from "./FeaturedQuestion.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedQuestion.vue?vue&type=style&index=0&id=4ae8b4f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae8b4f0",
  null
  
)

export default component.exports